import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';

const SoftwareRmTickets = ({
  fetchRmSoftwareTicket,
  rmSoftwareTicket,
  rmSoftwareTicketFilter,
  getRmSoftwareTicketsFilterDropDown,
}) => {
  const headers = [
    'RM Ticket ID',
    'PM Complain ID',
    'City',
    'Created On',
    'Assigned To',
    'Site Number',
    'Client Name',
    'Area Name',
    'Status',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState();

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  useEffect(() => {
    const installationCont = JSON.parse(
      localStorage.getItem("rmTicketCont") &&
        localStorage.getItem("rmTicketCont")
    );
    if(installationCont){
      localStorage.setItem("rmList", JSON.stringify(""));
      localStorage.setItem("rmTicketCont", 0);
    }
    
  }, []);

  useEffect(() => {
    setTimeout(() => {
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
        setIsRoleId(roles);
      })();
    }, 1000);
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    localStorage.setItem("rmList", JSON.stringify(filterData));
    setFilterData(filterData);
    await fetchRmSoftwareTicket(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      if (fetchRmSoftwareTicket) {
        const dashBoardFilter = await JSON.parse(
          localStorage.getItem("dashBoardFilter") &&
            localStorage.getItem("dashBoardFilter")
        );
        const getcontractFilter = await JSON.parse(
          localStorage.getItem("rmList") &&
            localStorage.getItem("rmList")
        );
        setIsLoading(true);
        // setFilterData({
        //   site_no: '',
        //   client_name: '',
        //   site_type: '',
        //   status: (dashBoardFilter && dashBoardFilter.status)?dashBoardFilter.status:'',
        //   assignee_ids: '',
        //   fd_ticket_id: "",
        //   fusion_ticket_id: "",
        //   fromDate: (dashBoardFilter && dashBoardFilter.fromFilterDate)?dashBoardFilter.fromFilterDate:'',
        //   toDate: (dashBoardFilter && dashBoardFilter.toFilterDate)?dashBoardFilter.toFilterDate:'',
        // });
        if(dashBoardFilter){
         localStorage.setItem("rmList", JSON.stringify(""));
         localStorage.setItem("pmSiteCont", 0);
          await fetchRmSoftwareTicket({
            site_no: '',
            client_name: '',
            site_type: '',
            status: (dashBoardFilter && dashBoardFilter.status)?dashBoardFilter.status:'',
            assignee_ids: '',
            fd_ticket_id: "",
            city_id: "",
            fusion_ticket_id: "",
            fromDate: (dashBoardFilter && dashBoardFilter.fromFilterDate)?dashBoardFilter.fromFilterDate:'',
            toDate: (dashBoardFilter && dashBoardFilter.toFilterDate)?dashBoardFilter.toFilterDate:'',
          });
        }
        else if(getcontractFilter){
            fetchRmSoftwareTicket(getcontractFilter);
        }
        else{
          await fetchRmSoftwareTicket({
            site_no: '',
            client_name: '',
            site_type: '',
            status: (dashBoardFilter && dashBoardFilter.status)?dashBoardFilter.status:'',
            assignee_ids: '',
            fd_ticket_id: "",
            city_id: "",
            fusion_ticket_id: "",
            fromDate: (dashBoardFilter && dashBoardFilter.fromFilterDate)?dashBoardFilter.fromFilterDate:'',
            toDate: (dashBoardFilter && dashBoardFilter.toFilterDate)?dashBoardFilter.toFilterDate:'',
          });
        }
       
        // await fetchRmSoftwareTicket();
        await getRmSoftwareTicketsFilterDropDown(2);
        setIsLoading(false);
        localStorage.setItem("dashBoardFilter", JSON.stringify(''));
      }
    })();
  }, [fetchRmSoftwareTicket]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await fetchRmSoftwareTicket(filterData,val.selected + 1);
    setIsLoading(false);
  };

  useEffect(() => {
    const actions1 = [
      { name: 'Action', link: '/dashboard/rm-view-details' },
      { name: 'Ticket Log', link: '/dashboard/rm-log' },
      // { name: 'Assign Ticket', link: '/dashboard/rm-assign-ticket' },
      { name: 'View Details', link: '/dashboard/rm-show' },
    ];

    const actions = [
      { name: 'View Details', link: '/dashboard/rm-view-details' },
      { name: 'Ticket Log', link: '/dashboard/rm-log' },
    ];

    const tableData = [
      'id',
      'complaint_id',
      'city_name',
      'created_ats',
      'assigned_to',
      'site_no',
      'client_name',
      'area_name',
      'status',
    ];
    if (rmSoftwareTicket && rmSoftwareTicket.resultSets) {
      const data = rmSoftwareTicket.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            created_ats: element.created_at,
            Action: isRoleId === 9 ? actions : actions1,
          }
        )
      );
      
      if (data.length > 0) {
        setListData(data);
      }else{
        setListData([]);
      }

      setPageCount(Math.ceil(rmSoftwareTicket.total / rmSoftwareTicket.per_page));
    }
  }, [rmSoftwareTicket]);

  return (
    <Layout
      title={localization.softwareRM}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      {console.log(listData)}
      <TableSection
        data={listData}
        isId={true}
        headers={headers}
        pageCount={pageCount}
        srNo={rmSoftwareTicket?.from}
        onPageChange={onPageChange}
        detailList={rmSoftwareTicket && rmSoftwareTicket.resultSets}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={0}
        listFilterData={rmSoftwareTicketFilter?.sites ? rmSoftwareTicketFilter : null}
        rmSoftwareTicketFilter
      />
    </Layout>
  );
};

export default SoftwareRmTickets;

